
import { site } from "../utils/site";

//首页
const ucIndex = site.soso.url("/lawyer/index");

//普通咨询忽略
const ucHideAsk = site.soso.url("/lawyer/hideAsk");

//普通咨询列表
const userManage = site.muc.url("/user/manage");

//普通咨询详情
// const getdetail = site.api.url("/ask/getdetail");

//普通咨询详情 新接口
const getdetail = site.pubapi.url("/ts/m/ask_detail");

//普通咨询第一次回复
const firstReply = site.api.url("/consult/reply");

//普通咨询第二次（包含）之后回复
const secondReply = site.ask.url("/ask/questioningClosely");


//一对一咨询列表
const userOnemanage = site.muc.url("/user/onemanage");


//一对一咨询详情
const getParticularsLawyer = site.api.url("/lawyer/getParticularsLawyer");

//一对一咨询第一次回复
const firstOtoReply = site.muc.url("/user/replyOneByOne");

//一对一咨询第二次（包含）之后回复
const secondOtoReply = site.muc.url("/user/questioningClosely");

//播放语音
const dowloadWxAudio = site.api.url("/index/dowloadWxAudio");

//电话咨询列表
const userPhone = site.muc.url("/user/phone");

//获取电话咨询状态
const getCallStaus = site.inlawyer.url("/lawyer/getCallStaus");

//修改电话咨询
const applycall = site.inlawyer.url("/lawyer/applycall");

//付费咨询追问
const getMyzwnew = site.muc.url("/user/getMyzwnew");

//付费咨询派单
const autoSendList = site.api.url("/consult/autoSendList");

//付费咨询接受
const acceptAutoSend = site.ask.url("/ask/acceptAutoSend");

//付费咨询忽略
const cancelAutoSend = site.ask.url("/ask/cancelAutoSend");

//总资产
const lawyerAsset = site.api.url("/lawyer/asset");

//资金明细
const getAskIncome = site.muc.url("/user/getAskIncome");

//提现验证短信
const withdraw_check = site.muc.url("/user/withdraw_check");

//提现记录
const balance = site.soso.url("/lawyer/balance");

//提现账号信息
const account = site.soso.url("/lawyer/account");

//发送验证码
const phoneCode = site.uc.url("/user/phoneCode");

//确认提现
const withdraw = site.muc.url("/user/withdraw");

//获取开关状态
const getSwitchSts = site.www.url("/lawyer/getSwitchSts");

//改变开关状态
const changeSwitch = site.www.url("/lawyer/changeSwitch");

//修改电话咨询信息
const modifyCallRelated = site.www.url("/lawyer/modifyCallRelated");

//创建订单
const payDocreate = site.pay.url("/pay/docreate");

//检查订单是否创建成功
const payCheckorder = site.pay.url("/pay/checkorder");

//律师认证信息
const getLawyerAuth = site.api.url("/ask/getLawyerAuthInfo");

//上传图片
const indexUpload = site.upload.url("/index/upload");

//上传图片
const uploadCrop = site.upload.url("/index/uploadcrop");

//修改律师资料
const register = site.muc.url("/user/register");

//页面footer
const pcinit = site.soso.url("/api/pcinit");

//退出登录
const loginout = site.uc.url("/pub/loginout");

//获取pubkey和token
const requestSignKey = site.uc.url("/pub/requestSignKey");

//修改密码
const editpass = site.uc.url("/user/editpass");

//验证手机号
const checkphone = site.uc.url("/user/checkphone");

//修改支付宝账号
const addAcount = site.muc.url("/user/addAcount");

//修改手机号
const phonebind = site.uc.url("/user/phonebind");

//修改认证验证
const beforeModRegisterCheckPhone = site.muc.url("/user/beforeModRegisterCheckPhone");

//新消息数量
const lawtips = site.ask.url("/consult/lawtips");

// 新消息去掉提醒 type=ff 付费 type=1v1 1对1
const lawtips_hide = site.ask.url("/consult/lawtips_hide");


// 律师主页-编辑资料初始化
const lawyerEditInit = site.api.url("/lawyer/getInfos");

// 律师主页-编辑资料提交
const lawyerEditSubmit = site.muc.url("/user/setLawyerInfo");

// 律师主页-编辑资料添加学历 
const lawyerEditAdd = site.muc.url("/channel/education_add");

// 律师主页-编辑资料获取所有学校
const lawyerEditSchool = site.pubapi.url("/lawz/comm/school");

const lawyerSchoolList = site.muc.url("/channel/education_list");

//删除教育经历
const elawyerSchoolDel = site.muc.url("/channel/education_del");

// 获取消息列表
const apiLtalk = site.pubapi.url("/ts/ltalk");

//发送消息
const tsdotalkApi = site.pubapi.url("/ts/dotalk");

//结束服务
const doclawendApi = site.pubapi.url("/ts/doclawend");

// 请求权限信息
const checkSwitchRight = site.pubapi.url("/checkSwitch");

//文书代写列表 
const ldoclist = site.pubapi.url("/ts/ldoclist")

//拒绝派单 
const docrefuse = site.pubapi.url("/ts/docrefuse")

//接单
const lgetc = site.pubapi.url("/ts/lgetc")

//新消息文书代写
const ldocRed = site.pubapi.url('/ts/index/ldoc_red')

// 查询电话号码
const apiPayCall = site.api.url("/ask/checkPayCall");

//修改一对一价格
const modifySet = site.lawyer.url("/index/modifySetting");

//用户端文书代写列表
const userdoclist = site.pubapi.url("/ts/doclist");

//用户端文书代写对话框
const usertalk = site.pubapi.url("/ts/talk");

//律师认证搜索律所
const lawfrim = site.pubapi.url("/ts/lawfrim/search");

// 是否已开通专栏
const checkOpenArticle = site.pubapi.url("/ts/news/checkOpen");

// 开通专栏
const doOpenArticle = site.pubapi.url("/ts/news/doOpen");

// 已发布文章列表
const publishList = site.pubapi.url("/ts/news/pubList");

// 待发布文章列表
const rePubListList = site.pubapi.url("/ts/news/rePubList");

// 草稿箱文章列表
const draftsList = site.pubapi.url("/ts/news/draftsList");

// 文章列表初始化接口
const articelInit = site.pubapi.url("/ts/news/listCount");

// 已发布文章列表 二次确定编辑接口
const articelEdit = site.pubapi.url("/ts/news/getRepubId");

// 删除文章接口
const articelDel = site.pubapi.url("/ts/news/articleDel");

// 文章详情页初始化接口
const articleDetailInit = site.pubapi.url("/ts/news/lawArticleInfo");

// 发布文章初始化接口
const publishInit = site.pubapi.url("/ts/news/infoInit");

// 发布文章接口
const publishSubmit = site.pubapi.url("/ts/news/postTj");

// 保存草稿接口
const draftsSave = site.pubapi.url("/ts/news/draftsSave");

// 删除草稿接口
const draftsDel = site.pubapi.url("/ts/news/draftsDel");

// 草稿标识符 发表新文章才需要请求
const getDraftsTemp = site.pubapi.url("/ts/news/getDraftsTemp");

// 推荐服务
const apiRecommend = site.pubapi.url("/ts/lawz/recommendService");


//一对一新接口
const apiGet1v1List = site.pubapi.url("/ts/lawz/get1v1List");

// 上传年检
const annualAddApi = site.pubapi.url("/ts/lawz/annualAdd");

//获取审核状态
const sxLawStatusApi = site.pubapi.url("/ts/lawz/sxLawStatus");

// 代表案例
const apiList = site.pubapi.url("/ts/docs/dlist");

//删除案例
const fetchDel = site.pubapi.url("/ts/docs/del");

// 添加代表案例
const fetchAdd = site.pubapi.url("/ts/docs/add");

// 添加代表案例详情
const fetchInit = site.pubapi.url("/ts/docs/detail");

// 修改代表案例
const fetchEdit = site.pubapi.url("/ts/docs/edit");

// 首页消息通知
const fetchSysmsg = site.pubapi.url("/ts/sysmsg/list");

// 首页 百科问答
const wendaIndex = site.pubapi.url("/ts/lawz/pc_wenda_index");

// 百科问答库
const listtj = site.pubapi.url("/ts/lawz/pc_wenda_list_tj");

// 百科问状态统计
const baicount = site.pubapi.url("/ts/lawz/pc_wenda_count");

// 百科问答列表
const bailiat = site.pubapi.url("/ts/lawz/my_wenda_list");

// 百科问答 详情页
const wendaListInfoApi = site.pubapi.url("/ts/lawz/my_wenda_info");

// 百科问答  抢答
const wendaListGit = site.pubapi.url("/ts/lawz/law_wenda_get");

// 百科问答放弃解答
const myWendaNnlock = site.pubapi.url("/ts/lawz/my_wenda_unlock");

// 百科问答 保存草稿
const myWendaDraft = site.pubapi.url("/ts/lawz/law_wenda_draft");

//百科问答 回答或修改
const myWendaAnswer = site.pubapi.url("/ts/lawz/law_wenda_answer");


export {
  ucIndex,
  userManage,
  ucHideAsk,
  userOnemanage,
  userPhone,
  getCallStaus,
  applycall,
  getMyzwnew,
  getAskIncome,
  lawyerAsset,
  getdetail,
  firstReply,
  secondReply,
  balance,
  getParticularsLawyer,
  firstOtoReply,
  secondOtoReply,
  phoneCode,
  dowloadWxAudio,
  withdraw,
  getSwitchSts,
  changeSwitch,
  modifyCallRelated,
  account,
  autoSendList,
  acceptAutoSend,
  cancelAutoSend,
  payDocreate,
  payCheckorder,
  getLawyerAuth,
  indexUpload,
  uploadCrop,
  pcinit,
  loginout,
  requestSignKey,
  editpass,
  checkphone,
  addAcount,
  phonebind,
  register,
  withdraw_check,
  beforeModRegisterCheckPhone,
  lawtips,
  lawtips_hide,
  lawyerEditInit,
  lawyerEditSubmit,
  lawyerEditAdd,
  lawyerEditSchool,
  lawyerSchoolList,
  elawyerSchoolDel,
  apiLtalk,
  doclawendApi,
  tsdotalkApi,
  checkSwitchRight,
  ldoclist,
  docrefuse,
  lgetc,
  ldocRed,
  apiPayCall,
  modifySet,
  userdoclist,
  usertalk,
  lawfrim,
  checkOpenArticle,
  doOpenArticle,
  publishList,
  rePubListList,
  draftsList,
  articelInit,
  articelDel,
  articelEdit,
  articleDetailInit,
  publishInit,
  publishSubmit,
  draftsSave,
  draftsDel,
  getDraftsTemp,
  apiRecommend,
  apiGet1v1List,
  annualAddApi,
  sxLawStatusApi,
  apiList,
  fetchDel,
  fetchAdd,
  fetchInit,
  fetchEdit,
  fetchSysmsg,
  listtj,
  baicount,
  bailiat,
  wendaListInfoApi,
  wendaListGit,
  myWendaNnlock,
  myWendaDraft,
  myWendaAnswer,
  wendaIndex
};


// WEBPACK FOOTER //
// ./src/webapi/api.js